/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth__LoginInputs */

const en_auth__login = /** @type {(inputs: Auth__LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in`)
};

/**
* | output |
* | --- |
* | "Log in" |
*
* @param {Auth__LoginInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth__login = /** @type {((inputs?: Auth__LoginInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth__LoginInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth__login(inputs)
});